import { Lightbulb } from 'lucide-react';

interface InsightCardProps {
  message: string;
}

const InsightCard = ({ message }: InsightCardProps) => {
  return (
    <div className="bg-wellness-peach-light/60 rounded-2xl p-4 border border-wellness-peach/20">
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-xl bg-wellness-peach/20 flex items-center justify-center flex-shrink-0 mt-0.5">
          <Lightbulb className="h-4 w-4 text-wellness-peach" />
        </div>
        <div>
          <h3 className="text-sm font-semibold text-foreground mb-0.5">Dato inteligente</h3>
          <p className="text-sm text-muted-foreground leading-relaxed">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default InsightCard;
